export default __webpack_public_path__ + "static/media/working.e6fdc3c7.svg";